import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React from 'react';
import '../../utils/assertions.es.js';
import { maestroComponent } from '../../utils/componentHelpers.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Chip } from '../Chip/Chip.es.js';
import { ChipGroup as ChipGroup$1 } from './styled.es.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var StyledSingleSelectChip = function StyledSingleSelectChip(_a) {
  var _b = _a,
      isChecked = _b.isChecked,
      onChange = _b.onChange,
      name = _b.name,
      value = _b.value,
      groupValue = _b.groupValue,
      isDisabled = _b.isDisabled,
      isLoading = _b.isLoading,
      isError = _b.isError,
      isChipsFillGroupWidth = _b.isChipsFillGroupWidth,
      direction = _b.direction,
      gutter = _b.gutter,
      props = __objRest(_b, ["isChecked", "onChange", "name", "value", "groupValue", "isDisabled", "isLoading", "isError", "isChipsFillGroupWidth", "direction", "gutter"]);

  var handleChange = function handleChange() {
    if (isError || isDisabled || isLoading) {
      return;
    }

    onChange([value]);
  };

  return (
    /* @__PURE__ */
    React.createElement(Chip, __spreadProps(__spreadValues({}, props), {
      isChecked: groupValue.includes(value),
      isDisabled: isDisabled,
      isError: isError,
      isLoading: isLoading,
      onClick: handleChange
    }))
  );
};

var StyledMultipleSelectChip = function StyledMultipleSelectChip(_c) {
  var _d = _c,
      groupValue = _d.groupValue,
      isChecked = _d.isChecked,
      isDisabled = _d.isDisabled,
      isError = _d.isError,
      isLoading = _d.isLoading,
      name = _d.name,
      onChange = _d.onChange,
      isChipsFillGroupWidth = _d.isChipsFillGroupWidth,
      direction = _d.direction,
      gutter = _d.gutter,
      value = _d.value,
      props = __objRest(_d, ["groupValue", "isChecked", "isDisabled", "isError", "isLoading", "name", "onChange", "isChipsFillGroupWidth", "direction", "gutter", "value"]);

  var newGroupValue = [];

  var handleChange = function handleChange() {
    if (isDisabled || isError) {
      return;
    }

    var inputs = groupValue.slice();

    for (var i in inputs) {
      if (!newGroupValue.includes(inputs[i]) && inputs[i] !== value) {
        newGroupValue.push(inputs[i]);

        if (!groupValue.includes(value) && !newGroupValue.includes(value)) {
          newGroupValue.push(value);
        }
      }
    }

    if (!inputs.length) {
      newGroupValue.push(value);
    }

    groupValue = newGroupValue;
    onChange(groupValue);
  };

  return (
    /* @__PURE__ */
    React.createElement(Chip, __spreadProps(__spreadValues({}, props), {
      isDisabled: isDisabled,
      isError: isError,
      isLoading: isLoading,
      isChecked: groupValue.includes(value),
      onClick: handleChange
    }))
  );
};

var Item = function Item(_e) {
  var _f = _e,
      onChange = _f.onChange,
      groupValue = _f.groupValue,
      value = _f.value,
      name = _f.name,
      isMultiSelect = _f.isMultiSelect,
      isDisabled = _f.isDisabled,
      isError = _f.isError,
      isLoading = _f.isLoading,
      isChecked = _f.isChecked,
      tooltipProps = _f.tooltipProps,
      isChipsFillGroupWidth = _f.isChipsFillGroupWidth,
      direction = _f.direction,
      gutter = _f.gutter,
      props = __objRest(_f, ["onChange", "groupValue", "value", "name", "isMultiSelect", "isDisabled", "isError", "isLoading", "isChecked", "tooltipProps", "isChipsFillGroupWidth", "direction", "gutter"]);

  var commonProps = {
    name: name,
    groupValue: groupValue,
    value: value,
    onChange: onChange,
    isChecked: isChecked,
    isDisabled: isDisabled,
    isError: isError,
    isLoading: isLoading,
    tooltipProps: tooltipProps,
    isChipsFillGroupWidth: isChipsFillGroupWidth,
    direction: direction,
    gutter: gutter
  };
  return isMultiSelect ?
  /* @__PURE__ */
  React.createElement(StyledMultipleSelectChip, __spreadValues(__spreadValues({}, commonProps), props)) :
  /* @__PURE__ */
  React.createElement(StyledSingleSelectChip, __spreadValues(__spreadValues({}, commonProps), props));
};

var StyledChipGroup = function StyledChipGroup(_g) {
  var _h = _g,
      shape = _h.shape,
      size = _h.size,
      isMultiSelect = _h.isMultiSelect,
      value = _h.value,
      kind = _h.kind,
      isInvertedCheckedKind = _h.isInvertedCheckedKind,
      onChange = _h.onChange,
      isChipsFillGroupWidth = _h.isChipsFillGroupWidth,
      _h$direction = _h.direction,
      direction = _h$direction === void 0 ? "horizontal" : _h$direction,
      _h$gutter = _h.gutter,
      gutter = _h$gutter === void 0 ? "xxs" : _h$gutter,
      children = _h.children,
      props = __objRest(_h, ["shape", "size", "isMultiSelect", "value", "kind", "isInvertedCheckedKind", "onChange", "isChipsFillGroupWidth", "direction", "gutter", "children"]);

  return (
    /* @__PURE__ */
    React.createElement(ChipGroup$1, __spreadValues({
      isChipsFillGroupWidth: isChipsFillGroupWidth,
      direction: direction,
      gutter: gutter
    }, props), React.Children.map(children, function (item) {
      return (
        /*#__PURE__*/
        React.cloneElement(item, {
          size: size,
          shape: shape,
          kind: kind,
          isInvertedCheckedKind: isInvertedCheckedKind,
          isDisabled: item.props.isDisabled,
          isChecked: item.props.isChecked,
          isLoading: item.props.isLoading,
          isError: item.props.isError,
          groupValue: value,
          onChange: onChange,
          isMultiSelect: isMultiSelect,
          isChipsFillGroupWidth: isChipsFillGroupWidth,
          direction: direction,
          gutter: gutter
        })
      );
    }))
  );
};

var compoundComponents = {
  Item: Item
};
var ChipGroup = maestroComponent("ChipGroup", StyledChipGroup, compoundComponents);
export { ChipGroup };